import {CheckCircleOutlined, HeartOutlined, StarOutlined, UserOutlined} from '@ant-design/icons';
import {Image} from 'antd';

import bgImg from '../../../assets/AboutBgImg.png'; 
import Kalapi2 from '../../../assets/AboutImg2.jpeg'; 
import Kalapi1 from '../../../assets/kalapiStore.jpeg'; 

const AboutUs = () => {
  const featuresData = [
    {
      id: 1,
      title: 'Quality You Can Trust',
      description:
      'Crafted with premium materials, our products are durable, reliable, and made to last.',
      icon: StarOutlined,
    },
    {
      id: 2,
      title: 'Designs for Every Occasion',
      description:
      'From daily use to special moments, our designs fit every lifestyle.',
      icon: UserOutlined,
    },
    {
      id: 3,
      title: 'Made for Your Convenience',
      description:
      'Thoughtfully designed for comfort, ease, and everyday use.',
      icon: HeartOutlined,
    },
    {
      id: 4,
      title: 'Trusted by Customers',
      description:
      'Loved and trusted by customers for quality and consistency.',
      icon: CheckCircleOutlined,
    },
  ];
  return (
    <div className={'w-full text-gray-800'}>

      {/* Hero Section */}
      <div
        className={'relative w-full md:h-[600px] h-[300px] bg-cover bg-center'}
        style={{backgroundImage: `url(${bgImg})`}}
      >
        {/* Title */}
        <div className={'absolute inset-0 bg-primary-600/30'} />
        <div className={'relative z-10 shadow-xl flex flex-col h-full items-center justify-center text-white'}>

          <p className={'md:text-6xl text-3xl text-primary-50 flex font-semibold w-full justify-center items-center font-instrument '}>About Our Store</p>
          <p className={'md:text-xl font-serif md:flex text-base text-primary-200 text-center font-medium max-w-5xl pt-6'}>
         Designed for every journey, our bags combine timeless style with reliable functionality.
          </p>
        </div>
      </div>

      <div className={'flex justify-center mt-20'}>
        <span className={'w-24 sm:w-32 h-1 bg-primary-600 rounded-full'}></span>
      </div>

      {/* Our Story Section */}
      <div className={'flex w-full justify-center items-center mt-16 md:px-20 px-6'}>
        <div className={'section grid md:gap-20 gap-5 md:grid-cols-2 grid-cols-1'}>
          <div className={' col-span-1 '}>
            <h1 className={'md:text-6xl font-serif text-4xl font-bold text-primary-900 md:mb-3'}>कलापी </h1>
            <p className={'md:text-lg text-base font-medium'}>
            Kalapi is a heritage brand with a legacy spanning over 75 years.<br />

The company specializes in thoughtfully curated seasonal products and premium corporate gifting solutions.<br />

Rooted in tradition, Kalapi blends timeless values with evolving market sensibilities. Its offerings reflect quality, craftsmanship, and attention to detail across every season.<br />

Over generations, Kalapi has built strong goodwill and a reputation for reliability. The brand stands as a symbol of trust, consistency, and long-term relationships. Kalapi serves individuals and organizations seeking meaningful and refined gifting experiences.<br />

With deep customer loyalty, the company continues to grow across generations. Kalapi remains committed to honoring its legacy while embracing the future.<br />
            </p>
          </div>

          <div className={'flex md:gap-6 gap-3 justify-center items-center  col-span-1'}>
            <img src={Kalapi1} className={'h-[150px] md:h-[350px] rounded-md shadow-lg'} alt={'Kalapi Store'} />
            <img src={Kalapi2} className={'h-[200px] md:h-[330px] mt-36 rounded-md shadow-lg'} alt={'Kalapi Store'} />
          </div>
        </div>
      </div>

      {/* CONTENT SECTIONS */}
      <div className={''}>
        <div className={'flex justify-center'}>
          <span className={'w-24 sm:w-32 h-1 bg-primary-600 rounded-full'}></span>
        </div>

        {/* Features Section */}
        <div className={'flex mt-20 p-4 w-full justify-center items-center'}>
          <div className={' section grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6'}>
            {featuresData.map(({id, title, description, icon: Icon}) => (
              <div
                key={id}
                className={'bg-primary-50 rounded-2xl shadow-md p-8 text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300'}
              >
                <div className={'flex justify-center mb-4 text-primary-800 text-3xl'}>
                  <Icon />
                </div>

                <h3 className={'text-lg font-semibold text-gray-800 mb-2'}>
                  {title}
                </h3>

                <p className={'text-gray-600 text-sm leading-relaxed'}>
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
